"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapView = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _MapViewModule = _interopRequireDefault(require("../../styles/components/Map/MapView.module.css"));
require("mapbox-gl/dist/mapbox-gl.css");
var _mapboxGlLanguage = _interopRequireDefault(require("@mapbox/mapbox-gl-language"));
var _reactRedux = require("react-redux");
var _actions = require("../../redux/actions");
var _MapContent = require("./MapContent");
var _selectors = require("../../redux/selectors");
var _reactMapGl = _interopRequireDefault(require("react-map-gl"));
var _marker = _interopRequireDefault(require("../../icons/marker.png"));
var _functions = require("../../utils/functions");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const defaultCenter = [49.45791170829136, 8.475063970425599];
const zoomThreshold = 16.68;
const MapView = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    nameForm,
    goTo
  } = _ref;
  const [lastCenter, setLastCenter] = (0, _react.useState)(defaultCenter);
  const [pitchInProgress, setPitchInProgress] = (0, _react.useState)(false);
  const dispatch = (0, _reactRedux.useDispatch)();
  const DataRef = (0, _react.useRef)({});
  const mapRef = (0, _react.useRef)(null);
  const {
    current: map
  } = mapRef;
  const sites = (0, _reactRedux.useSelector)((0, _selectors.getFilteredDataById)(nameForm), _paulCorePackage.functions.areEqual) || [];
  const [mapboxLanguage] = (0, _react.useState)(new _mapboxGlLanguage.default({
    defaultLanguage: 'en'
  }));
  const activeSiteId = (0, _reactRedux.useSelector)(_selectors.selectActiveSiteId);
  const isAutoZoom = (0, _reactRedux.useSelector)(_selectors.getHasZoom);
  const hasPitch = (0, _reactRedux.useSelector)(_selectors.getHasPitch);
  const setHasPitchFunc = e => {
    dispatch((0, _actions.setHasPitch)(e.target.getPitch() === 70));
    setPitchInProgress(false);
  };
  (0, _react.useEffect)(() => {
    if (map && pitchInProgress && Math.abs(zoomThreshold - (map === null || map === void 0 ? void 0 : map.getZoom())) < 0.5) {
      if ((map === null || map === void 0 ? void 0 : map.getPitch()) !== 70) {
        map === null || map === void 0 ? void 0 : map.flyTo({
          pitch: 70,
          essential: true // animation will happen even if user has `prefers-reduced-motion` setting on
        });
      } else if ((map === null || map === void 0 ? void 0 : map.getPitch()) !== 0) map === null || map === void 0 ? void 0 : map.flyTo({
        pitch: 0,
        essential: true // animation will happen even if user has `prefers-reduced-motion` setting on
      });
    }
  }, [map, pitchInProgress]);
  const show3D = (0, _react.useCallback)(() => {
    var _mapRef$current;
    const currentZoom = (_mapRef$current = mapRef.current) === null || _mapRef$current === void 0 ? void 0 : _mapRef$current.getZoom();
    if (!pitchInProgress) {
      var _mapRef$current2;
      const currentPitch = (_mapRef$current2 = mapRef.current) === null || _mapRef$current2 === void 0 ? void 0 : _mapRef$current2.getPitch();
      const inTransitionZone = Math.abs(currentZoom - zoomThreshold) < 0.05;
      if (currentZoom > zoomThreshold && inTransitionZone && currentPitch !== 70) {
        setPitchInProgress(true);
      } else if (currentPitch !== 0 && currentZoom <= zoomThreshold && inTransitionZone) {
        setPitchInProgress(true);
      } else setPitchInProgress(false);
    } else if (currentZoom <= zoomThreshold && pitchInProgress) setPitchInProgress(false);
  }, [pitchInProgress, setPitchInProgress, mapRef]);
  const handleOnZoom = (0, _react.useCallback)(show3D, [show3D]);
  const handleOnClick = () => {
    if (!DataRef.current.disabledMap) {
      dispatch((0, _actions.setActiveSite)(null));
      dispatch((0, _actions.setHasZoom)(false));
    }
  };
  let hoveredStateId = null;
  const handleOnLoad = (0, _react.useCallback)(_m => {
    const map = _m.target;
    const mouseover = (feature, map) => {
      hoveredStateId = feature.id;
      map.getCanvasContainer().style.cursor = 'pointer';
      map.setFeatureState({
        source: 'cluster-source',
        id: hoveredStateId
      }, {
        hover: true
      });
    };
    const mouseout = map => {
      if (!hoveredStateId && hoveredStateId !== 0) return;
      map.getCanvasContainer().style.cursor = '';
      map.setFeatureState({
        source: 'cluster-source',
        id: hoveredStateId
      }, {
        hover: false
      });
      hoveredStateId = null;
    };
    map.addControl(mapboxLanguage);
    map.loadImage(_marker.default, (error, image) => {
      if (error) throw error;
      map.addImage('icon-marker', image);
    });
    map.on('mousemove', 'marker', e => {
      if (e.features[0]) {
        mouseover(e.features[0], map);
      } else {
        mouseout(map);
      }
    });

    // Reset the state-fills-hover layer's filter when the mouse leaves the layer.
    map.on('mouseleave', 'marker', () => {
      mouseout(map);
    });
  }, [mapboxLanguage]);
  const autoShow3D = (0, _react.useCallback)(() => {
    if (DataRef.current.isAutoZoom) {
      const currentZoom = map.getZoom();
      map.flyTo({
        zoom: currentZoom > 18 ? currentZoom + 2 : 18,
        essential: true
      });
      DataRef.current.disabledMap = true;
      const handleGoTo = () => {
        dispatch((0, _actions.setHasZoom)(false));
        dispatch((0, _actions.setHasPitch)(false));
        setTimeout(() => {
          goTo({
            site: DataRef.current.site
          });
        }, 400);
      };
      if (currentZoom === 20) {
        handleGoTo();
      } else setTimeout(() => handleGoTo(), 100);
    }
  }, [goTo, map, dispatch]);
  (0, _react.useEffect)(() => {
    DataRef.current.disabledMap = false;
  }, [activeSiteId, dispatch]);
  (0, _react.useEffect)(() => {
    if (activeSiteId) {
      const pointPosition = sites.find(point => point.id === activeSiteId);
      if (pointPosition) {
        setLastCenter(pointPosition.coordinates);
      }
    }
  }, [activeSiteId, sites]);
  (0, _react.useEffect)(() => {
    DataRef.current.site = sites.find(site => site.id === activeSiteId);
  }, [activeSiteId, sites]);
  (0, _react.useEffect)(() => {
    DataRef.current.isAutoZoom = isAutoZoom;
  }, [isAutoZoom]);
  (0, _react.useEffect)(() => {
    if (isAutoZoom && hasPitch) autoShow3D();
  }, [isAutoZoom, hasPitch, autoShow3D]);
  (0, _react.useEffect)(() => {
    if (map && (sites === null || sites === void 0 ? void 0 : sites.length) !== 0 && !activeSiteId) {
      const coordinates = sites.map(point => point.coordinates);
      const bounds = (0, _functions.getBounds)(coordinates);
      map.fitBounds(bounds, {
        padding: {
          top: 100,
          bottom: 460
        }
      });
    }
  }, [map, sites, activeSiteId]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-center ".concat(_MapViewModule.default.map_wrap)
  }, /*#__PURE__*/_react.default.createElement(_reactMapGl.default, {
    id: "map-gl-main-map",
    ref: mapRef,
    mapStyle: "mapbox://styles/dinhnext/ckzffp6yb000r14mzosbce2f2",
    mapboxAccessToken: "pk.eyJ1IjoicGF1bGdtYmgiLCJhIjoiY2t6Y3dnODg5MG12cTM0bzZsdnZsaHdybCJ9.KjtOa-eiZg8jeTcBKUEUbQ",
    initialViewState: {
      latitude: defaultCenter[0],
      longitude: defaultCenter[1],
      zoom: 11.5,
      pitch: 0,
      transitionDuration: 0.5,
      maxPitch: 85
    },
    center: lastCenter,
    scrollZoom: !pitchInProgress,
    touchZoom: !pitchInProgress,
    keyboard: !pitchInProgress,
    doubleClickZoom: !pitchInProgress,
    onZoom: handleOnZoom,
    onLoad: handleOnLoad,
    onPitchEnd: setHasPitchFunc,
    onClick: handleOnClick
  }, /*#__PURE__*/_react.default.createElement(_MapContent.MapContent, {
    nameForm: nameForm,
    ref: mapRef
  })));
});
exports.MapView = MapView;